const internationalConferences = [
    
    {
        id: 22,
        role: 'PC Member',
        conference: '47th International Conference on Software Engineering (ICSE), In Practice',
        year: '2025'
    },
    {
        id: 23,
        role: 'PC Member',
        conference: '48nd International Conference on Software Engineering (ICSE), Research Track',
        year: '2026'
    },
    {
        id: 24,
        role: 'PC Member',
        conference: '47th International Conference on Software Engineering (ICSE), Student Research Competition',
        year: '2025'
    },
    {
        id: 25,
        role: 'PC Member',
        conference: 'AIWare 2025',
        year: '2025'
    },
    {
        id: 26,
        role: 'PC Member',
        conference: '34th International Conference on ACM International Conference on the Foundations of Software Engineering (FSE) 2025',
        year: '2025'
    },
    {
        id: 21,
        role: 'PC Chair',
        conference: '28th International Conference on Evaluation and Assessment in Software Engineering (EASE), Industry Track',
        year: '2025'
    },
    {
        id: 1,
        role: 'Publicity Chair',
        conference: '18th International Conference on Software and Systems Processes',
        year: '2024'
    },
    {
        id: 2,
        role: 'PC Member',
        conference: '46th International Conference on Software Engineering (ICSE), Research Track',
        year: '2024'
    },
    {
        id: 3,
        role: 'PC Member',
        conference: '39th IEEE/ACM International Conference on Automated Software Engineering',
        year: '2024'
    },
    {
        id: 4,
        role: 'PC Member',
        conference: '28th International Conference on Evaluation and Assessment in Software Engineering',
        year: '2024'
    },
    {
        id: 5,
        role: 'PC Member',
        conference: '18th ACM/IEEE International Symposium on Empirical Software Engineering and Measurement',
        year: '2024'
    },
    {
        id: 6,
        role: 'PC Member',
        conference: '28th International Conference on Evaluation and Assessment in Software Engineering, Short papers, Vision and Emerging Results Track',
        year: '2024'
    },
    {
        id: 7,
        role: 'PC Member',
        conference: 'International Doctoral Symposium on Empirical Software Engineering (IDoESE)',
        year: '2023'
    },
    {
        id: 8,
        role: 'PC Chair',
        conference: '27th International Conference on Evaluation and Assessment in Software Engineering, Industry Track',
        year: '2023'
    },
    {
        id: 9,
        role: 'PC Member',
        conference: 'ACM/IEEE International Symposium on Empirical Software Engineering and Measurement',
        year: '2023'
    },
    {id: 10, role: 'Member', conference: '17th International Conference on Software and Systems Process', year: '2023'},
    {
        id: 11,
        role: 'Steering Committee Member',
        conference: 'International Conference on Software and Systems Process',
        year: '2021 - 2024'
    },
    {
        id: 12,
        role: 'PC Chair',
        conference: '20nd International Conference on Software and Systems Process',
        year: '2020'
    },
    {
        id: 13,
        role: 'Publicity Chair',
        conference: '16th International Conference on Software and Systems Processes',
        year: '2022'
    },
    {
        id: 14,
        role: 'PC Member',
        conference: 'ACM/IEEE International Symposium on Empirical Software Engineering and Measurement',
        year: '2022'
    },
    {
        id: 15,
        role: 'PC Member',
        conference: '15th International Conference on Software and Systems Processes',
        year: '2021'
    },
    {
        id: 16,
        role: 'PC Member',
        conference: '43th International Conference on Software Engineering (ICSE)',
        year: '2021'
    },
    {
        id: 17,
        role: 'PC Member',
        conference: 'ACM/IEEE International Symposium on Empirical Software Engineering and Measurement',
        year: '2021'
    },
    {
        id: 18,
        role: 'PC Member',
        conference: 'ACM/IEEE International Symposium on Empirical Software Engineering and Measurement',
        year: '2020'
    },
    {
        id: 19,
        role: 'PC Member',
        conference: 'ACM/IEEE International Symposium on Empirical Software Engineering and Measurement',
        year: '2019'
    },
    {
        id: 20,
        role: 'PC Member',
        conference: '41th International Conference on Software Engineering (ICSE), In Practice',
        year: '2019'
    },

];

export default internationalConferences;
